import React from 'react';
import Reflux from 'reflux';
import i18 from '../../../i18';
import {supplierRuleApi} from '../../../api';
import RuleViewModal from '../rules/RuleViewModal';
import RowProcessed from './assignment/RowProcessed';
import RowUnprocessed from './assignment/RowUnprocessed';

class Assignment extends Reflux.Component {

    constructor(props) {
        super(props);

        this.state = {
            showProcessedItems: false,
            creatingRule: false,
            showRule: null,
        };
    }

    getCompanyId = () => {
        return this.props.config.company_id;
    };

    getErrorMessage = (error, fallbackMessage) => {
        if (
            error
            && error.response
            && error.response.data
        ) {
            const responseData = error.response.data;

            if (
                responseData.error
                && responseData.error.message
            ) {
                return responseData.error.message;
            }

            if (responseData.message) {
                return responseData.message;
            }
        }

        return fallbackMessage;
    };

    createRule = async (event, ruleData) => {
        if (event && typeof event.preventDefault === 'function') {
            event.preventDefault();
        }

        if (this.state.creatingRule) {
            return false;
        }

        this.setState({
            creatingRule: true,
        });

        try {
            const responseData = await supplierRuleApi.create(
                this.getCompanyId(),
                ruleData,
            );

            this.props.updateRules(
                responseData.supplierRules || [],
            );

            return true;
        } catch (error) {
            this.props.notifyError(
                this.getErrorMessage(
                    error,
                    'Hiba történt a szabály létrehozása során. (#2002)',
                ),
            );

            return false;
        } finally {
            this.setState({
                creatingRule: false,
            });
        }
    };

    deleteInvoiceItem = (invoiceItemId) => {
        const invoices = (this.props.invoices || []).reduce(
            (result, invoice) => {
                const items = (invoice.items || []).filter(
                    (invoiceItem) => (
                        invoiceItem._internalId !== invoiceItemId
                    ),
                );

                if (items.length > 0) {
                    result.push({
                        ...invoice,
                        items,
                    });
                }

                return result;
            },
            [],
        );

        this.props.updateInvoices(
            invoices,
            this.props.supplierRules || [],
        );
    };

    deleteInvoice = (invoiceId) => {
        const invoices = (this.props.invoices || []).filter(
            (invoice) => (
                invoice._internalId !== invoiceId
            ),
        );

        this.props.updateInvoices(
            invoices,
            this.props.supplierRules || [],
        );
    };

    removeRemainingInvoices = () => {
        const invoices = (this.props.invoices || []).reduce(
            (result, invoice) => {
                const items = (invoice.items || []).filter(
                    (invoiceItem) => Boolean(
                        invoiceItem.main_bookkeeping_number,
                    ),
                );

                if (items.length > 0) {
                    result.push({
                        ...invoice,
                        items,
                    });
                }

                return result;
            },
            [],
        );

        this.props.updateInvoices(
            invoices,
            this.props.supplierRules || [],
        );

        this.props.nextStep();
    };

    showHideProcessedItems = () => {
        this.setState((previousState) => ({
            showProcessedItems:
                !previousState.showProcessedItems,
        }));
    };

    hasUnprocessedInvoices = () => {
        return (this.props.invoices || []).some(
            (invoice) => (invoice.items || []).some(
                (invoiceItem) => (
                    !invoiceItem.main_bookkeeping_number
                ),
            ),
        );
    };

    hasProcessedInvoices = () => {
        return (this.props.invoices || []).some(
            (invoice) => (invoice.items || []).some(
                (invoiceItem) => Boolean(
                    invoiceItem.main_bookkeeping_number,
                ),
            ),
        );
    };

    onShowRule = (ruleId) => {
        const rule = (this.props.supplierRules || []).find(
            (supplierRule) => (
                String(supplierRule.id) === String(ruleId)
            ),
        );

        if (!rule) {
            this.props.notifyError(
                `A #${ruleId} szabály nem található.`,
            );

            return;
        }

        this.setState({
            showRule: rule,
        });
    };

    closeModal = () => {
        this.setState({
            showRule: null,
        });
    };

    listInvoices = () => {
        const rows = [];

        (this.props.invoices || []).forEach(
            (invoice) => {
                (invoice.items || []).forEach(
                    (invoiceItem) => {
                        if (
                            invoiceItem.main_bookkeeping_number
                        ) {
                            return;
                        }

                        rows.push(
                            <RowUnprocessed
                                key={`unprocessed-${invoiceItem._internalId}`}
                                invoice={invoice}
                                invoiceItem={invoiceItem}
                                vatCollectorCodes={
                                    this.props.vatCollectorCodes || []
                                }
                                creatingRule={
                                    this.state.creatingRule
                                }
                                onCreateRule={this.createRule}
                                deleteInvoiceItem={
                                    this.deleteInvoiceItem
                                }
                                deleteInvoice={
                                    this.deleteInvoice
                                }
                                notifySuccess={
                                    this.props.notifySuccess
                                }
                                notifyError={
                                    this.props.notifyError
                                }
                            />,
                        );
                    },
                );
            },
        );

        return rows;
    };

    listProcessedInvoices = () => {
        const rows = [];

        (this.props.invoices || []).forEach(
            (invoice) => {
                (invoice.items || []).forEach(
                    (invoiceItem, invoiceItemIndex) => {
                        if (
                            !invoiceItem.main_bookkeeping_number
                        ) {
                            return;
                        }

                        rows.push(
                            <RowProcessed
                                key={`processed-${invoiceItem._internalId}`}
                                invoice={invoice}
                                invoiceItem={invoiceItem}
                                itemIndex={invoiceItemIndex}
                                config={this.props.config}
                                deleteInvoiceItem={this.deleteInvoiceItem}
                                deleteInvoice={this.deleteInvoice}
                                notifySuccess={this.props.notifySuccess}
                                notifyError={this.props.notifyError}
                                onShowRule={this.onShowRule}
                            />,
                        );
                    },
                );
            },
        );

        return rows;
    };

    renderUnprocessedTableHeader = () => {
        return (
            <tr>
                <th>{i18.SUPPLIER._invoiceNumber}</th>
                <th>Szállító neve</th>
                <th>Vevő neve</th>
                <th>Tétel megnevezés</th>
                <th>{i18.SUPPLIER._positionNumberCountry}</th>
                <th>{i18.SUPPLIER._orderNumberStat}</th>
                <th>Főkönyv szám</th>
                <th>ÁFA százalék</th>
                <th>ÁFA gyűjtő kód</th>
                <th>ÁFA fők. szám</th>
                <th style={{width: '140px'}}>{i18.COMPANY._operations}</th>
            </tr>
        );
    };

    renderProcessedTableHeader = () => {
        return (
            <tr>
                <th>Szabály</th>
                <th>{i18.SUPPLIER._invoiceNumber}</th>
                <th>Szállító neve</th>
                <th>Vevő neve</th>
                <th>Tétel megnevezés</th>
                <th>{i18.SUPPLIER._positionNumberCountry}</th>
                <th>{i18.SUPPLIER._orderNumberStat}</th>
                <th>Főkönyv szám</th>
                <th>ÁFA százalék</th>
                <th>ÁFA gyűjtő kód</th>
                <th>ÁFA fők. szám</th>
                <th style={{width: '110px'}}>{i18.COMPANY._operations}</th>
            </tr>
        );
    };



    renderUnprocessedInvoices = () => {
        if (!this.hasUnprocessedInvoices()) {
            return (
                <div className="text-center margin-top-50 margin-bottom-50">
                    <p>
                        Minden számlához sikerült szabályt
                        rendelni.
                    </p>

                    <button
                        type="button"
                        onClick={this.props.nextStep}
                        className="next-step"
                    >
                        {i18.BUTTONS._goToDownload}
                    </button>
                </div>
            );
        }

        return (
            <table className="table table-striped table-aibook-no-border">
                <thead>
                {this.renderUnprocessedTableHeader()}
                </thead>

                <tbody>
                {this.listInvoices()}
                </tbody>
            </table>
        );
    };

    renderProcessedInvoices = () => {
        if (
            !this.state.showProcessedItems
            || !this.hasProcessedInvoices()
        ) {
            return null;
        }

        return (
            <table className="table table-striped table-aibook-no-border">
                <thead>
                {this.renderProcessedTableHeader()}
                </thead>

                <tbody>
                {this.listProcessedInvoices()}
                </tbody>
            </table>
        );
    };

    renderActions = () => {
        const hasUnprocessedInvoices =
            this.hasUnprocessedInvoices();

        const hasProcessedInvoices =
            this.hasProcessedInvoices();

        return (
            <div className="next-step-btn-container margin-top-50 margin-bottom-50 text-left">
                <button
                    type="button"
                    onClick={this.showHideProcessedItems}
                    className="next-step"
                    disabled={!hasProcessedInvoices}
                >
                    {this.state.showProcessedItems
                        ? i18.BUTTONS._hideProcessedItems
                        : i18.BUTTONS._showProcessedItems
                    }
                </button>

                {hasUnprocessedInvoices ? (
                    <button
                        type="button"
                        onClick={this.removeRemainingInvoices}
                        className="pull-right table-gray-btn"
                    >
                        Maradék tételek kihagyása
                    </button>
                ) : null}
            </div>
        );
    };

    renderEmptyState = () => {
        return (
            <div className="col-lg-12 text-center margin-top-50">
                <p>
                    Nincs feldolgozandó számla a lekérésben!
                </p>
            </div>
        );
    };

    render() {
        const invoices = this.props.invoices || [];

        const {
            showRule,
        } = this.state;

        if (invoices.length === 0) {
            return this.renderEmptyState();
        }

        return (
            <section id="supplier-assignment">
                <div className="container-fluid">
                    {this.renderUnprocessedInvoices()}
                    {this.renderActions()}
                    {this.renderProcessedInvoices()}
                </div>
                {showRule
                    ? (
                        <RuleViewModal
                            config={this.props.config}
                            rule={showRule}
                            closeModal={this.closeModal}
                        />
                    )
                    : null}
            </section>
        );
    }
}

export default Assignment;



// WEBPACK FOOTER //
// ./src/components/supplier/steps/Assignment.js